import * as React from 'react'
import { render } from 'react-dom'
import { BrowserRouter as Router, Route, Switch, Link } from 'react-router-dom'
import Home from './components/routes/Home'
import store from './store'
import { Provider } from 'react-redux'
import Imprint from './components/routes/Imprint'
import './index.css'
import StationOverview from './components/station/StationOverview'
import Wish from './components/routes/Wish'
import WishSaved from './components/routes/WishSaved'
import 'antd-mobile/dist/antd-mobile.css'
import GetCurrentLocation from './components/location/GetCurrentLocation'
import Wishes from './components/routes/Wishes'

interface RootProps {}

const Root: React.SFC<RootProps> = ({}) => {
  return (
    <Provider store={store}>
      <React.Fragment>
        <GetCurrentLocation />
        <Router>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Route path="/" exact={true} component={Home} />
            <Route path="/imprint/" exact={true} component={Imprint} />
            <Switch>
              <Route path="/map" render={props => <Wishes {...props} />} />
              <Route path="/category/:type/wish-saved" render={props => <WishSaved {...props} />} />
              <Route path="/category/:type/wish" render={props => <Wish {...props} />} />
              <Route path="/category/:type/map" render={props => <Wishes {...props} />} />
              <Route path="/category/:type/" render={props => <StationOverview {...props} />} />
            </Switch>
            <div
              style={{
                backgroundColor: 'rgb(50, 50, 50)',
                padding: 8,
                display: 'flex',
                color: 'white',
                justifyContent: 'space-around',
              }}
            >
              <Link to="/" style={{ marginRight: 10, color: 'white' }}>
                Home
              </Link>
              <Link to="/map" style={{ marginRight: 10, color: 'white' }}>
                Map
              </Link>
              <a href="https://www.peerigon.com" style={{ marginRight: 10, color: 'white' }}>
                Made by Peeribility
              </a>
              <Link style={{ color: 'white' }} to="/imprint">
                Impressum
              </Link>
            </div>
          </div>
        </Router>
      </React.Fragment>
    </Provider>
  )
}

export default Root
render(<Root />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.tsx